import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { token } from "@/styled-system/tokens";
import { abbr } from "../../node_modules/@zillow/formatters/dist/formatters.esm.esm.js";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import PropInterpolatorWrapper from "../PaymentDonutChart/Chart/common/PropInterpolator.esm.js";
import LineChart from "../PaymentDonutChart/LineChart/LineChart.esm.js";
import withDimensions from "../PaymentDonutChart/withDimensions.esm.js";
import { useLastValidPayemntValues, safe } from "./VALoanCalculator.utils.esm.js";
const GRAPH_HEIGHT = 275;
const lineChartShell = css({
  position: "relative",
  paddingTop: "120px"
});
const legendIndexFormatter = (x) => x === null ? null : `${x} month${x !== 1 ? "s" : ""}`;
const xAxisFormatter = safe((x) => x + " mo");
const yAxisFormatter = safe((x) => "$" + abbr(x));
const getAccessibleValue = (index, message) => index % 12 === 0 ? message : "";
const VALoanCalculatorBase = ({
  containerWidth
}) => {
  const colors = [token.var("colors.bg.accent.green.impact"), token.var("colors.bg.accent.aqua.impact"), token.var("colors.bg.accent.purple.impact")];
  const form = useFormContext();
  const lastValidValues = useLastValidPayemntValues(form);
  const chartDataProps = lastValidValues.calculations.amortization;
  const lineData = useMemo(() => {
    const {
      principal,
      interest,
      remaining
    } = chartDataProps.reduce((acc, {
      totalPrincipal,
      totalInterest,
      remainingBalance
    }, i) => ({
      principal: [...acc.principal, {
        x: i,
        y: totalPrincipal,
        accessibleValue: getAccessibleValue(i, "Principal paid")
      }],
      interest: [...acc.interest, {
        x: i,
        y: totalInterest,
        accessibleValue: getAccessibleValue(i, "Interest paid")
      }],
      remaining: [...acc.remaining, {
        x: i,
        y: remainingBalance,
        accessibleValue: getAccessibleValue(i, "Remaining balance")
      }]
    }), {
      principal: [],
      interest: [],
      remaining: []
    });
    return [{
      name: "Principal",
      formatter: (value) => (
        // eslint-disable-next-line no-restricted-globals
        isNaN(value) || value === null ? null : getWholeDollars(value)
      ),
      values: principal
    }, {
      name: "Interest",
      formatter: (value) => (
        // eslint-disable-next-line no-restricted-globals
        isNaN(value) || value === null ? null : getWholeDollars(value)
      ),
      values: interest
    }, {
      name: "Remaining",
      formatter: (value) => (
        // eslint-disable-next-line no-restricted-globals
        isNaN(value) || value === null ? null : getWholeDollars(value)
      ),
      values: remaining
    }];
  }, [chartDataProps]);
  return /* @__PURE__ */ jsx("div", { className: lineChartShell, children: /* @__PURE__ */ jsx(LineChart, { containerWidth, legend: false, legendIndexFormatter, margins: {
    top: 10,
    right: 50,
    bottom: 40,
    left: 20
  }, data: lineData, colors: (i) => colors[i], xHideOrigin: true, xAxisTickCount: 3, xAxisFormatter, yAxisTickCount: 4, yAxisFormatter, lineWidth: 2, axesColor: token.var("colors.border.neutral"), tickTextStroke: token.var("colors.text.neutral"), height: GRAPH_HEIGHT, displayDataPoints: false, "aria-label": "Mortgage payoff schedule chart", xAxisLabel: "Months", yAxisLabel: "Paid amount", "aria-hidden": "true", fontFamily: token.var("fonts.ui") }) });
};
const VALoanCalculatorLineChart = PropInterpolatorWrapper(withDimensions(VALoanCalculatorBase, {
  defaultWidth: 550,
  defaultHeight: null
}));
export {
  VALoanCalculatorLineChart as default
};
